export default "__VITE_PUBLIC_ASSET__f027bfd1__"